
import React, { useEffect, useState } from 'react';
import styles from './ToolList.module.css';
import { getToolsFromFirestore, deleteToolFromFirestore } from '../../firebase/toolService';
import { findPostsUsingTool, replaceToolInPosts } from '../../firebase/toolPostReplaceService';
import { useAuth } from '../../firebase/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';

// ToolReplaceページから戻ってきたときの置換・削除副作用
function ToolListReplaceEffect({ location, fetchTools, navigate }) {
  useEffect(() => {
    if (location.state && location.state.replaceWith && location.state.toolId) {
      (async () => {
        await replaceToolInPosts(location.state.toolId, location.state.replaceWith);
        await deleteToolFromFirestore(location.state.toolId);
        fetchTools();
        navigate('/tools', { replace: true });
      })();
    }
    // eslint-disable-next-line
  }, [location.state]);
  return null;
}


const ToolList = () => {
  const [toolList, setToolList] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // 道具一覧取得
  const fetchTools = async () => {
    if (!user) return;
    const tools = await getToolsFromFirestore(user.uid);
    setToolList(tools);
  };

  useEffect(() => {
    fetchTools();
    // eslint-disable-next-line
  }, [user]);

  // 道具削除
  const handleDelete = async (toolId) => {
    // 投稿で使われているか確認
    const usedPosts = await findPostsUsingTool(toolId);
    if (usedPosts.length > 0) {
      // 置換ページへ遷移
      navigate('/tools/replace', { state: { toolId } });
    } else {
      // そのまま削除
      await deleteToolFromFirestore(toolId);
      fetchTools();
    }
  };

  return (
    <>
      <ToolListReplaceEffect location={location} fetchTools={fetchTools} navigate={navigate} />
      <div className={styles.container}>
        <h2>道具一覧</h2>
        <button
          className={styles.button}
          style={{ marginBottom: 16 }}
          onClick={() => navigate('/tools')}
        >
          道具を追加・管理する
        </button>
        {toolList.length === 0 ? (
          <div>登録された道具はありません。</div>
        ) : (
          <ul className={styles.toolList}>
            {toolList.map((tool, idx) => (
              <li key={tool.id || idx} className={styles.toolItem}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div
                    className={styles.toolName}
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => navigate(`/tools/detail/${tool.id}`)}
                  >
                    {tool.name}
                  </div>
                  <button
                    className={styles.button}
                    style={{ background: '#e53935', marginLeft: 8, padding: '4px 14px', fontSize: '0.95em' }}
                    onClick={() => handleDelete(tool.id)}
                  >
                    削除
                  </button>
                </div>
                {tool.images && tool.images.length > 0 && (
                  <div className={styles.imagePreviewArea}>
                    {tool.images.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt={`道具画像${i + 1}`}
                        className={styles.imagePreview}
                      />
                    ))}
                  </div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default ToolList;
